// extracted by mini-css-extract-plugin
module.exports = {"dot":"Dot_dot__1S5bP","dotCurrent":"Dot_dotCurrent__ehqdd"};